import React from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';

const InputReactSelect = ({
  name,
  value,
  onChange,
  loadOptions,
  options,
  placeholder,
  isClearable,
  isSearchable,
  defaultOptions,
  isMulti,
  isDisabled,
  className,
  noOptionsMessage,
  formatOptionLabel,
  cacheOptions,
  defaultValue,
  isAsync,
  additional,
  isLoading,
  loadingMessage,
}) => {
  const handleChange = (selected) => {
    onChange({
      target: {
        name,
        value: isMulti ? selected : selected?.value || '',
      },
    });
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: 38,
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  const commonProps = {
    name,
    value,
    onChange: handleChange,
    isMulti,
    isClearable,
    isSearchable,
    isDisabled,
    className,
    placeholder,
    noOptionsMessage,
    formatOptionLabel,
    defaultValue,
    styles: customStyles,
    isLoading,
    loadingMessage,
    ...additional,
  };

  // Return AsyncSelect if isAsync is true and loadOptions is provided
  if (isAsync && loadOptions) {
    return (
      <AsyncSelect
        {...commonProps}
        loadOptions={loadOptions}
        defaultOptions={defaultOptions}
        cacheOptions={cacheOptions}
      />
    );
  }

  // Return regular Select for non-async options
  return <Select {...commonProps} options={options} />;
};

InputReactSelect.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    }),
  ]),
  // For async options
  loadOptions: PropTypes.func,
  // For regular options
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string.isRequired,
    })
  ),
  placeholder: PropTypes.string,
  isClearable: PropTypes.bool,
  isSearchable: PropTypes.bool,
  defaultOptions: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
  isMulti: PropTypes.bool,
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
  noOptionsMessage: PropTypes.func,
  formatOptionLabel: PropTypes.func,
  cacheOptions: PropTypes.bool,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array,
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    }),
  ]),
  isAsync: PropTypes.bool,
  additional: PropTypes.shape({}),
  isLoading: PropTypes.bool,
  loadingMessage: PropTypes.func,
};

InputReactSelect.defaultProps = {
  value: null,
  loadOptions: null,
  options: null,
  placeholder: 'Select...',
  isClearable: true,
  isSearchable: true,
  defaultOptions: true,
  isMulti: false,
  isDisabled: false,
  className: '',
  noOptionsMessage: () => 'No options found',
  formatOptionLabel: undefined,
  cacheOptions: true,
  defaultValue: null,
  isAsync: false,
  additional: {},
  isLoading: false,
  loadingMessage: () => 'Loading...',
};

export default InputReactSelect;
